import {
  Dialog
} from 'vant';
const appCommon = {
    browser: {
        versions: (function () {
            var u = navigator.userAgent,
                app = navigator.appVersion;
            return {
                trident: u.indexOf("Trident") > -1, //IE内核
                presto: u.indexOf("Presto") > -1, //opera内核
                webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
                gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
                mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                android: u.indexOf("Android") > -1 || u.indexOf("Adr") > -1, //android终端
                iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
                iPad: u.indexOf("iPad") > -1, //是否iPad
                webApp: u.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
                weixin: u.indexOf("MicroMessenger") > -1, //是否微信
                qq: u.match(/\sQQ/i) == " qq", //是否QQ
            };
        })(),
        language: (
            navigator.browserLanguage || navigator.language
        ).toLowerCase(),
    },

    appConfig: {
        iosDriver: ["wseaser://com.wsecar.wsjcsj/splash", ""],
        androidDriver: ["wseaser://com.wsecar.wsjcsj/splash", ""],
        iosPassenger: [
            "wsjc://com.wsecar.wsjc/splash",
            "https://itunes.apple.com/cn/app/id1180877789?mt=8",
        ],
        androidPassenger: [
            "wsjc://com.wsecar.wsjc/splash",
            "https://a.app.qq.com/o/simple.jsp?pkgname=com.wsecar.wsjc",
        ],
    },

    openClient() {
        if (this.browser.versions.ios) {
            window.location.href = this.appConfig.iosPassenger[1];
        } else if (this.browser.versions.weixin) {
            Dialog.alert({
              title: '万顺叫车',
              message: "点击右上角按钮，然后在弹出的菜单中，点击在" +
                (this.browser.versions.ios ? "Safari" : "浏览器") +
                "中打开，即可安装",
            }).then(() => {
              // on close
            });
        } else if (this.browser.versions.android) {
            window.location.href = this.appConfig.androidPassenger[0];
            setTimeout(() => {
                window.location.href = this.appConfig.androidPassenger[0];
                setTimeout(() => {
                    var windowHidden =
                        window.document.hidden ||
                        window.document.mozHidden ||
                        window.document.msHidden ||
                        window.document.webkitHidden;
                    if (
                        typeof windowHidden == "undefined" ||
                        windowHidden == false
                    ) {
                        window.location.href = this.appConfig.androidPassenger[1];
                    }
                }, 3000);
            }, 1000);
        } else {
            window.location.href = this.appConfig.androidPassenger[1];
        }
    }
};
export default appCommon;
